import React from 'react';
import { useLegalAuth } from '../hooks/useLegalAuth';

export default function SuperAdminRoute({ children }) {
  const { isSuperAdmin } = useLegalAuth();
  if (!isSuperAdmin) {
    return <div style={{ padding: 40, textAlign: 'center' }}>Access Denied. Super Admin only.</div>;
  }
  return children;
}
